import { IconAlfaLogo } from '@alfa-bank/site-icon/alfa-logo';
import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { Portal } from '@alfa-bank/site-portal';
import { Stack, stackingOrder } from '@alfa-bank/site-stack';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { CloseIcon } from './close-icon';
import { Modal as Component } from './desktop/modal';
import styles from './desktop/styles.css';
import type { IDepsDesktop, TPropsDesktop } from './models';

export const ModalDesktop = createWidget<IDepsDesktop, TPropsDesktop>({
    CloseIcon,
    IconAlfaLogo,
    Layout,
    Portal,
    Stack,
    stackingOrder,
    styles,
})(Component);
